import { BRANDCHOSEN } from "../hooks/config"

export class CollectionFilter {
    collectionName
    filterType = 'collection'
    constructor(collectionName) {
        this.collectionName = collectionName
    }

    apply(products) {
      if(products[BRANDCHOSEN] != undefined) products = products[BRANDCHOSEN]
        return products.filter(product => {
            return (product.Coleccion.toLowerCase() === this.collectionName.toLowerCase())
        })
    }
}